export default "__VITE_ASSET__DKCiRMOY__"